import { TYPES } from '../../common/constants';
import * as client from '../../services/client';

export const getWalkThroughSuitesDone = payload => ({
    type: TYPES.GET_WALK_THROUGH_SUITES,
    payload,
  });

  export const getWalkthroughSuites = (propertyId) => dispatch => {
    return client.getWalkthroughSuites(propertyId).then(response => {  
      if(response.ok){
        response.json().then( responsejson => {
          // dispatch(getWalkThroughSuitesDone(responsejson.data))
          dispatch(getWalkThroughSuitesDone(responsejson))
        })
      } else {
        // alert('some thing went wrong in get walkthrough suites')
      }
    })
  }